import React from 'react';
import { Box, FormLabel, Menu } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
import { useGetAllActionTypesSuspense } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import MultiFilter from '../../../modules/MultiFilter/MultiFilter';
const ActionsFilterWrapper = ({ onApply, selectedActionIds }) => {
    const { data: actionTypesResponse } = useGetAllActionTypesSuspense({
        query: { staleTime: Infinity },
    });
    const availableActionTypes = unwrapModel(actionTypesResponse);
    if (!availableActionTypes)
        return null;
    const selectedValues = selectedActionIds?.map((action) => action.toString()) ?? [];
    const multiSelectOptions = [
        {
            title: '',
            selectedValues,
            items: availableActionTypes.map((actionType) => ({
                title: actionType.name,
                value: actionType.id.toString(),
            })),
        },
    ];
    const handleApply = (values) => {
        onApply(values.map((value) => Number(value)));
    };
    return (React.createElement(Box, null,
        React.createElement(FormLabel, { "data-testid": "actions__form_label" }, localise('ACTIONS')),
        React.createElement(Menu, { closeOnSelect: false, variant: "multi-select-long" },
            React.createElement(MultiFilter, { selectionGroups: multiSelectOptions, selectedValues: selectedValues, onApply: handleApply }))));
};
export default ActionsFilterWrapper;
